<template>
    <ol class="wrapper">
        <li class="h6">Step</li>
        <li
            v-for="n in total"
            :key="n"
            :class="{ 'step--active': n == current }"
            class="step"
            @click="$emit('changeStep', n)"
        >
            {{ n }}
        </li>
    </ol>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            required: true,
        },
        current: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
    .wrapper {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: flex-end;
        margin-top: 1em;

        @media screen and (max-width: 434px) {
            border-top: 1px solid #DDD;
            margin-left: -28px;
            margin-right: -28px;
            margin-bottom: -55px;
            padding: 10px 28px;
        }

        li {
            margin-left: 1em;
            cursor: pointer;

            &:first-child {
                margin-left: 0;
            }
        }
    }
</style>
